import { Button, Icon, Icons, Paragraph, Popover } from "@ir/ui";

interface MasterDataSearchByProps {
  fields: readonly string[];
  title?: string;
}

/**
 * Informational Search by control: icon trigger opens a Popover listing static fields.
 * Does not change search query params.
 */
export function MasterDataSearchBy({
  fields,
  title = "Search By",
}: Readonly<MasterDataSearchByProps>) {
  return (
    <Popover
      className="master-data-search-by"
      placement="bottom start"
      focusable
      title={<Paragraph className="text-grey-700 m-0 p-0 text-sm font-bold">{title}</Paragraph>}
      content={
        <ul className="master-data-search-by__list ps-4">
          {fields.map((field) => (
            <li key={field} className="master-data-search-by__item">
              <Paragraph className="text-grey-700 m-0">{field}</Paragraph>
            </li>
          ))}
        </ul>
      }
    >
      <Button
        size="small"
        variant="clear"
        className="master-data-search-by__trigger"
        aria-label="Search by"
        htmlTitle="Search by"
      >
        <Icon
          name={Icons.InfoCircle}
          size="small"
          color="grey"
          style={{ color: "var(--grey-400)" }}
        />
      </Button>
    </Popover>
  );
}
